import http from "@/common/http.service";
const ROOT_URL = "apikey/list";
const DELETE_URL = "apikey/delete";
/* const AUTHENTICATE_URL = 'domain/authenticate'
const USER_SAVE = 'domain/save' */
const APIKEY_SAVE = "apikey/generate";
const APIKEY_RENAME = "apikey/edit";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = {
        items: response.data.list_data,
        total: response.data.list_count,
      };
      cb(data);
    });
  },

  delete(id) {
    return http.post(DELETE_URL + "/" + id, {});
  },
};

export const saveApiKey = (params) => {
  return http.post(APIKEY_SAVE, params);
};

export const renameApiKey = (params) => {
  return http.post(APIKEY_RENAME, params);
};

/* export const authenticateDomain = (id) => {
  return http.post(AUTHENTICATE_URL, { id: id })
} */
